import React, { useEffect, useState } from "react";
import styles from '../components/landing-page/lp.styles';
import '../components/landing-page/lp.css';
import CountdownTimer from '../components/landing-page/CountdownTimer';
import LeftHero from "../components/landing-page/LeftHero";
import RemIntro from "../components/intro/RemIntro";
import TokenDrivers from "../components/drivers/TokenDrivers";
import Slider from "../components/remSlider/slider";
import Countdown2 from "../components/countdown2/Countdown2";
import RemRoadmap from "./RemRoadmap";
import { toast } from "react-toastify";

const calculatePaddingTop = () => {
    if (window.innerHeight >= 900 && window.innerHeight <= 1000) {
        return '40px';
    } else if (window.innerHeight >= 800 && window.innerHeight < 900) {
        return '80px';
    } else if (window.innerHeight >= 600 && window.innerHeight < 800) {
        return '140px';
    }
    else {
        return '170px'
    }
};

const LandingPage = () => {
    const [screenWidth, setScreenWidth] = useState(window.innerWidth);
    const [paddingTop, setPaddingTop] = useState(calculatePaddingTop());

    useEffect(() => {
        const handleResize = () => {
            setScreenWidth(window.innerWidth);
            setPaddingTop(calculatePaddingTop());
            console.log(window.innerWidth);
        };

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    return (
        <>
            <div className="landing-main-div" style={{ backgroundColor: "black" }}>
                <div style={styles.container}>
                    <section className="formContainer" style={screenWidth > 1124 ? { ...styles.formContainer, paddingTop } : styles.formContainerResp}>
                        <LeftHero />
                        {window.innerWidth > 1024 ? <CountdownTimer /> : null}
                    </section>
                    <Countdown2 />
                </div>
                <Slider />
                <div data-aos="fade-up" data-aos-duration="900" style={{ background: "black" }}>
                    <TokenDrivers />
                </div>
                <div className="intro-outer-div" data-aos="fade-up" data-aos-duration="800">
                    <RemIntro />
                </div>
                <div style={{ backgroundColor: "black" }}>
                    <RemRoadmap />
                </div>
            </div>
        </>
    );
};

export default LandingPage;
